import api, { adminApi } from "./api";

// ─── Public ────────────────────────────────────────────────────────────────
export const getPolicyByTypeApi = (type) => {
  return api.get(`/api/v1/policies/${type}`);
};

export const getAllPoliciesApi = () => {
  return api.get("/api/v1/policies/all");
};

// ─── Admin ─────────────────────────────────────────────────────────────────
export const listPoliciesAdminApi = (params = {}) => {
  return adminApi.get("/api/v1/policies/admin/list", { params });
};

export const getPolicyByIdAdminApi = (policyId) => {
  return adminApi.get(`/api/v1/policies/admin/detail/${policyId}`);
};

export const createPolicyApi = (data) => {
  return adminApi.post("/api/v1/policies", data);
};

export const updatePolicyApi = (policyId, data) => {
  return adminApi.put(`/api/v1/policies/admin/${policyId}`, data);
};

export const deletePolicyApi = (policyId) => {
  return adminApi.delete(`/api/v1/policies/admin/${policyId}`);
};

// ─── Metadata ──────────────────────────────────────────────────────────────
// รายการประเภท policy ที่ฝั่ง backend รองรับ (controllers/policy.js: VALID_TYPES)
export const POLICY_TYPES = [
  { value: "terms", label: "ข้อกำหนดการใช้งาน", group: "ข้อกำหนด/นโยบาย" },
  { value: "privacy", label: "นโยบายความเป็นส่วนตัว", group: "ข้อกำหนด/นโยบาย" },
  { value: "payment", label: "เงื่อนไขการชำระเงิน", group: "ข้อกำหนด/นโยบาย" },
  { value: "payment_partner", label: "เงื่อนไขการชำระเงิน (พาร์ทเนอร์)", group: "ข้อกำหนด/นโยบาย" },
  { value: "payment_store", label: "เงื่อนไขการชำระเงิน (ร้านค้า)", group: "ข้อกำหนด/นโยบาย" },
  { value: "payment_rider", label: "เงื่อนไขการชำระเงิน (ไรเดอร์)", group: "ข้อกำหนด/นโยบาย" },
  { value: "announcement_member", label: "ประกาศสำหรับสมาชิก", group: "ประกาศ" },
  { value: "announcement_partner", label: "ประกาศสำหรับพาร์ทเนอร์", group: "ประกาศ" },
  { value: "announcement_store", label: "ประกาศสำหรับร้านค้า", group: "ประกาศ" },
  { value: "announcement_rider", label: "ประกาศสำหรับไรเดอร์", group: "ประกาศ" },
  { value: "prohibited_products", label: "ข้อกำหนดสินค้าต้องห้าม", group: "สินค้าต้องห้าม" },
];

export const policyTypeLabel = (value) => {
  const found = POLICY_TYPES.find((t) => t.value === value);
  return found ? found.label : value;
};
